"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedMapDataType = void 0;
var AggregatedMapDataType;
(function (AggregatedMapDataType) {
    AggregatedMapDataType[AggregatedMapDataType["Country"] = 10] = "Country";
    AggregatedMapDataType[AggregatedMapDataType["Area"] = 15] = "Area";
    AggregatedMapDataType[AggregatedMapDataType["AreaLocality"] = 18] = "AreaLocality";
    AggregatedMapDataType[AggregatedMapDataType["Locality"] = 20] = "Locality";
    AggregatedMapDataType[AggregatedMapDataType["Building"] = 25] = "Building";
    AggregatedMapDataType[AggregatedMapDataType["BuildingProperty"] = 30] = "BuildingProperty";
    AggregatedMapDataType[AggregatedMapDataType["Property"] = 35] = "Property";
})(AggregatedMapDataType = exports.AggregatedMapDataType || (exports.AggregatedMapDataType = {}));
